import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalPoliciesRoute: InvariantJiraRoute = {
	name: 'eoc-policies',
	path: '/jira/settings/products/ops/policies',
	exact: true,
};
